import * as OperatorLoginType from '../../app/state/OperatorLoginType.ts';
import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { Maybe } from 'dg-web-shared/lib/MaybeV2.ts';
import * as ServerStateSlice from 'dg-web-shared/lib/ServerStateSlice.ts';
import * as Http from '../../api/Http.ts';
import * as AsyncRequest from '../../AsyncRequest.ts';

export interface Permissions {
    operatorAppActive: boolean;
    enforcementAppActive: boolean;
    parkingpayModule: boolean;
    taxomexModule: boolean;
    transactions: boolean;
    permitsRead: boolean;
    permitsWrite: boolean;
    activityStatement: boolean;
    whitelistCreate: boolean;
    whitelistDelete: boolean;
    userPermissionEdit: boolean;
    enforcementLog: boolean;
    syncApp: boolean;
    usbStickEdit: boolean;
    parkingMeterEdit: boolean;
    parkingMeterAlerts: boolean;
    twintQrCodePairing: boolean;
    refundParkTransactions: boolean;
    refundPermits: boolean;
    quotasWrite: boolean;
    parkingaboInitialBalanceCreate: boolean;
    cloudConnectorOffstreetDevicesView: boolean;
    cloudConnectorRecodeTicket: boolean;
    cloudConnectorAutoRecode: boolean;
    cloudConnectorAlerts: boolean;
    cloudConnectorReportingAccess: boolean;
    masterDataAndStatistics: boolean;
    parkingaboUserEdit: boolean;
    eventsRead: boolean;
    eventsWrite: boolean;
}

export interface OperatorLogin {
    operatorLoginId: number;
    operatorId: number;
    operatorLoginType: OperatorLoginType.OperatorLoginType;
    firstName: string;
    lastName: string;
}

export namespace List {
    export type State = ServerStateSlice.ServerState<OperatorLogin[]>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parseOperatorLogin = (l: any): OperatorLogin => {
        return {
            ...l,
            operatorLoginType: OperatorLoginType.fromString(
                l.operatorLoginType,
            ),
        };
    };

    export const { get, reset, setResponse } =
        ServerStateSlice.generateServerState<OperatorLogin[]>(
            'operator-logins-OperatorLogins',
            () => [],
            (store: Flux.Store, state: State) => {
                if (state.shouldFetch) {
                    store.update(fetchOperatorLogins);
                }
            },
            body => body.map(parseOperatorLogin),
        );

    const fetchOperatorLogins = AsyncRequest.request(
        Http.OperatorAccount.OperatorLogins.logins,
        setResponse,
    );
}

export const getLoginById = (
    logins: OperatorLogin[],
    id: number,
): Maybe<OperatorLogin> => logins.find(l => l.operatorLoginId === id);

export const getLoginTitle = (l: OperatorLogin): string =>
    `${l.lastName} ${l.firstName}`;
